<template>
  <section class="fast-collect-dialog-container">
    <el-dialog
      class="fast-collect-dialog"
      title="快速采集"
      width="900px"
      v-loading="loading"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :before-close="beforeClose"
    >
      <header>
        <div class="url-wrap">
          <el-input disabled :value="getUrl" size="small"></el-input>
        </div>
        <el-button type="primary" size="small" v-if="status===1"
          :disabled="status === 3"
          @click="handlePause"
        >暂停</el-button>
        <el-button type="primary" size="small" v-if="status===2"
          :disabled="status === 3"
          @click="handleRecover"
        >恢复</el-button>
        <el-button type="primary" size="small"
          :disabled="status === 3"
          @click="handleStop"
        >结束</el-button>
      </header>
      <div class="iframe-wrap" v-if="getUrl">
        <iframe
          ref="myIframe"
          :src="getUrl"
          frameborder="0"
          security="restricted"
          sandbox=""
          @load='iframeLoad'></iframe>
      </div>
      <el-tabs type="card" v-model="activeTab"
        @tab-click="handleClickTab"
        :before-leave="beforeLeave">
        <el-tab-pane label="运行日志" name="1">
          <div class="total-wrap">
            <span>{{getStatus}}，</span>
            <span>用时 <span class="jee-color">21</span> 秒，</span>
            <span>已抓取到 <span class="jee-color">{{data.length}}</span> 条数据</span>
          </div>
          <div class="title">详细日志</div>
          <div class="log-wrap scrollbar" id="log">
            <ul>
              <template v-for="(item, index) in data">
                <li :key="index">
                  {{item}}
                </li>
              </template>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">数据（{{data.length}}）</span>
          <base-table
            v-bind="list"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </section>
</template>
<script>
import qs from 'qs'
import baseTable from '@/components/mixins/baseTable'

export default {
  name: 'FastCollectDialog',
  mixins: [baseTable],
  props: {
    modelType: {
      type: [String, Number],
      default: -1
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      iframeLoaded: false,
      taskId: '',
      activeTab: '1',
      runtime: 0,
      total: 0,
      status: 1, // 1采集中，2暂停，3结束
      data: [
        '12/11 10:56:06:开始请求',
        'https://m.weibo.cn/api/container/getIndexcontainerid=1076031642634100&page=1',
        '12/11 10:56:07:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=2',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=3',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=4',
        '12/11 10:56:09:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=5',

        '12/11 10:56:06:开始请求',
        'https://m.weibo.cn/api/container/getIndexcontainerid=1076031642634100&page=1',
        '12/11 10:56:07:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=2',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=3',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=4',
        '12/11 10:56:09:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=5',
        '12/11 10:56:06:开始请求',
        'https://m.weibo.cn/api/container/getIndexcontainerid=1076031642634100&page=1',
        '12/11 10:56:07:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=2',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=3',
        '12/11 10:56:08:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=4',
        '12/11 10:56:09:开始请求',
        'https://m.weibo.cn/api/container/getIndex?containerid=1076031642634100&page=5'
      ],
      list: {
        columns: [],
        showSelection: false,
        showPagination: false
      }
    }
  },
  computed: {
    getUrl () {
      // （1中国政府网2百度搜索词3微博4公众号）
      switch (this.modelType) {
        case 1:
          return 'http://sousuo.gov.cn/column/31421/0.htm'
        case 2:
          const query = qs.stringify({
            wd: this.keyword,
            ie: 'utf-8',
            rqlang: 'cn'
          })
          console.log(query)
          return `https://www.baidu.com/s?${query}`
        default:
          return ''
      }
    },
    getStatus () {
      switch (this.status) {
        case 1:
          return '正在进行'
        case 2:
          return '[已暂停]'
        case 3:
          return '已完成'
        default:
          return '未开始'
      }
    }
  },
  methods: {
    showDialog (id) {
      this.taskId = id
      this.dialogVisible = true
    },
    handleCancel () {
      this.loading = false
      this.dialogVisible = false
    },
    beforeClose (done) {
      if (this.status !== 3) {
        this.handleStop()
      }
      done()
    },
    cancelBtnLoading () {
      this.loading = false
    },
    handlePause () {
      this.loading = true
      this.status = 2
      this.$request.fetchCollectPause(this.taskId).then(this.cancelBtnLoading).catch(this.cancelBtnLoading)
    },
    handleRecover () {
      this.loading = true
      this.status = 1
      this.$request.fetchCollectRecover(this.taskId).then(this.cancelBtnLoading).catch(this.cancelBtnLoading)
    },
    handleStop () {
      this.loading = true
      this.status = 3
      this.$request.fetchCollectStop(this.taskId).then(this.cancelBtnLoading).catch(this.cancelBtnLoading)
    },
    // 加载完成
    iframeLoad (e) {
      const iframeNode = this.$refs.myIframe.contentWindow
      console.log(iframeNode)
    },
    handleClickTab (tab) {
      this.activeTab = tab.name
    },
    beforeLeave (activeName, oldActiveName) {
      if (activeName === '2' && this.status === 1) {
        this.$message('请先暂停或结束任务')
        return false
      }
      if (activeName === '2') {
        this.fetchCollectContentList()
      }
      return true
    },
    fetchCollectContentList () {
      this.list.loading = true
      const params = {
        taskId: this.taskId
      }
      this.$request.fetchCollectContentList(params).then(res => {
        if (res.code === 200) {
          this.list.columns = res.data.title.map(d => {
            return {
              prop: d.field,
              label: d.label
            }
          })
          this.list.data = res.data.list
        }
        this.list.loading = false
      }).catch(() => {
        this.list.loading = false
      })
    }
  },
  mounted () {
    const host = this.$path.replace(/^http(s)?/, 'ws')
    this.websocket = new WebSocket(`${host}/webSocket/zhuliequn`)
    this.websocket.onopen = function (ev) {
      console.log(ev)
    }
    this.websocket.onclose = function (ev) {
      console.log(ev)
      this.data = []
    }
    this.websocket.onmessage = function (ev) {
      console.log(ev.data)
      this.data.push(ev.data)
      this.$nextTick(() => {
        var ele = document.getElementById('log')
        if (ele.scrollHeight > ele.clientHeight) {
          ele.scrollTop = ele.scrollHeight
        }
      })
    }
  },
  beforeDestroy () {
    this.websocket && this.websocket.close()
  }
}
</script>
<style lang="scss" scoped>
.fast-collect-dialog{
  .el-dialog{
    header{
      display: flex;
      justify-content: space-between;
      .url-wrap{
        flex: 1;
      }
      .el-button{
        margin-left: 10px;
      }
    }
    .iframe-wrap{
      margin-top: 20px;
      overflow: auto;
      height: 260px;
      border-radius: 4px;
      border: 1px solid #e8e8e8;

      iframe{
        width: 100%;
        height: 100%;
      }
    }
    .el-tabs{
      margin-top: 20px;
      .el-tab-pane{
        color: #333333;
        .total-wrap{
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
        }
        .title{
          line-height: 30px;
          background-color: #f0f0f0;
          padding: 0 20px;
        }
        .log-wrap{
          background-color: #FFFFE1;
          height: calc(80vh - 560px);
          overflow-x: hidden;
          overflow-y: auto;
          ul{
            padding: 17px 20px;
            li{
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
